import { CapabilityService } from "@/features/audio/interfaces/browser-services.interface";
import { BrowserCapabilities } from "@/features/audio/types/browser-capabilities.types";
import { isIosDevice } from "@/utils/is-ios-device";
import { isSafariBrowser } from "@/utils/is-safari-browser";

const hasMediaDevices = (): boolean => typeof navigator !== "undefined" && Boolean(navigator.mediaDevices);

const supportsSetSinkId = (): boolean => {
    if (typeof HTMLMediaElement === "undefined") {
        return false;
    }

    return "setSinkId" in HTMLMediaElement.prototype;
};

export class BrowserCapabilityService implements CapabilityService {
    detect(): BrowserCapabilities {
        const ios = isIosDevice();
        const hasDevices = hasMediaDevices();
        const outputRouting = supportsSetSinkId() && !ios;

        return {
            canSelectMicrophone: hasDevices && !ios,
            canSelectSpeaker: hasDevices && outputRouting,
            supportsOutputRouting: outputRouting,
            supportsDeviceEnumeration: hasDevices,
            supportsBackgroundAudio: !ios,
            supportsNotifications: typeof Notification !== "undefined",
            requiresUserGestureForAudio: isSafariBrowser() || ios,
        };
    }
}

export const browserCapabilityService = new BrowserCapabilityService();
